// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_sz-0";